import React, { useState, useEffect } from "react";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietTaiSan } from "./ChiTietTaiSan/BtnChiTietTaiSan";

export const ContentTable = ({ listKiemKhoFull, listDaKiemKho, onKiemKho }) => {
  // Tạo một state để lưu trạng thái của các checkbox đã chọn
  const [checkedItems, setCheckedItems] = useState({});
  useEffect(() => {
    // checkedItems=listDaKiemKho;
    const initialCheckedItems = listKiemKhoFull.reduce((acc, item) => {
      acc[item.MaTaiSan] = item.TrangThai === 1;
      return acc;
    }, {});
    setCheckedItems(initialCheckedItems);
  }, [listKiemKhoFull]);

  // Hàm xử lý khi checkbox thay đổi
  const handleCheckboxChange = (itemId, index) => {
    const newCheckedStatus = !checkedItems[itemId.MaTaiSan];
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [itemId.MaTaiSan]: newCheckedStatus,
    }));
    // Gọi onKiemKho để xử lý logic thêm
    onKiemKho(itemId.MaTaiSan, newCheckedStatus);
  };

  return listKiemKhoFull.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.STT}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-26 flex-basis-23-6-sm">
        <span className="mobile-column-name">Mã tài sản</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.MaTaiSan}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
        <span className="mobile-column-name">Tên tài sản</span>
        <div className="center-wrapper color7">
          <p className="text-left">
            <BtnChiTietTaiSan item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper color7">
          <p className="text-center">
            <BtnChiTietHopDong item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-11-4-sm ">
        <span className="mobile-column-name">Tên kho</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.Kho}</p>
        </div>
      </div>
      {/* <div className="custom-table-cell flex-basis-9 flex-basis-9-sm action-cell">
        <input
          type="checkbox"
          checked={listDaKiemKho.indexOf(item.MaTaiSan) > -1 || false}
          onChange={() => handleCheckboxChange(item, index)}
        />
        <div
          className="text-center"
          style={{ cursor: "pointer", marginRight: "10px" }}
        >
        </div>
      </div> */}

      <div className="custom-table-cell flex-basis-10 flex-basis-15-sm ">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper color7">
          <p className="text-center">
            {listDaKiemKho.indexOf(item.MaTaiSan) > -1 && (
              <span className="dang-vay">Đã kiểm</span>
            )}
            {listDaKiemKho.indexOf(item.MaTaiSan) < 0 &&
              item.TrangThai === 0 && (
                <span className="color-do-bold canh-bao-red-v2">Chưa kiểm</span>
              )}
            {item.TrangThai === 1 && <span className="dang-vay">Đã kiểm</span>}
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-9 flex-basis-9-sm action-cell">
        <div
          className="text-center"
          style={{ cursor: "pointer", marginRight: "10px" }}
          onClick={() => handleCheckboxChange(item, index)}
        >
          <img
            src={
              listDaKiemKho.indexOf(item.MaTaiSan) > -1
                ? "/app-assets/images/turn-on-v2.png"
                : "/app-assets/images/turn-off-v2.png"
            }
            alt="Trạng thái đã xem"
            // style={{ width: "20px" }}
          />
        </div>
      </div>
    </div>
  ));
};
